
import { gsap, ScrollTrigger } from "gsap/all";
import Lenis from "@studio-freight/lenis";
import ProductFeed from "./components/product-feed";

export default function Animations() {

	gsap.registerPlugin(ScrollTrigger);
	const lenis = new Lenis({  smoothWheel: true,  duration: 1.6,  easing: t => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t)),});
	lenis.on('scroll', ScrollTrigger.update);
	gsap.ticker.add((time) => {lenis.raf(time * 1000);});
	gsap.ticker.lagSmoothing(0);

	let windowWidth = window.innerWidth;

	if (windowWidth > 1279) {
		new ProductFeed();
	}

	window.addEventListener('resize', () => {
		windowWidth = window.innerWidth;
		if (windowWidth > 1279) {
			new ProductFeed();
		}
	});

}
